














































































































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import moment from 'moment';
import { permil } from '@/utils/finance';
import { reportList, middlePageList, creatDownloadTask, downloadTaskcheckTask } from '@/api/report';
import { searchByName } from '@/api/common';
import { middlePageColumns, unrealizedColmunObj, realizedColmunObj } from '@/utils/report';
import downloadStreamFile from '@/assets/js/downloadStreamFile';
import { mapGetters } from 'vuex';
import { pathPermission } from '@/utils/utils';

//1-正常在管, 2-writedown到0，3-writeoff， 5-完全退出，6-部分退出，全部非drop项目
const statusList: any[] = [
  { name: '全部非drop项目', value: 0 },
  { name: '正常在管', value: 1 },
  { name: 'write down到0', value: 2 },
  { name: 'write off', value: 3 },
  { name: '完全退出', value: 5 },
  { name: '部分退出', value: 6 }
];

// const currencyList: any[] = [
//   {
//     name: '全部币种',
//     value: 0
//   },
//   {
//     name: '人民币',
//     value: 1
//   },
//   {
//     name: '美元',
//     value: 2
//   },
//   {
//     name: '人民币及美元',
//     value: 3
//   }
// ];

const sumMap = {
  investmentCost: 'totalCostUsd',
  unrealizedinvestmentCostCny: 'unRealizedCostCny',
  unrealizedinvestmentCostUsd: 'unRealizedCostUsd',
  unrealizedfmvCny: 'unRealizedFmvCny',
  unrealizedfmvUsd: 'unRealizedFmvUsd',
  realizedinvestmentCostCny: 'realizedCostCny',
  realizedinvestmentCostUsd: 'realizedCostUsd',
  realizedproceedsCny: 'proceedCny',
  realizedproceedsUsd: 'proceedUsd'
};

@Component({
  components: {},
  computed: { ...mapGetters(['userInfo']) }
})
class MIDDLEPAGEREPORT extends Vue {
  userInfo: any;
  columns: any[] = [];
  data: any[] = [];
  page: number = 1;
  pageSize: number = 20;
  // middlePageColumns: any[] = middlePageColumns;
  weight: string = '10000';
  unrealizedFold: boolean = true;
  realizedFold: boolean = true;
  nickName: string = '';
  NickNameList: any[] = [];
  currency: number = 0;
  // currencyList: any[] = currencyList;
  hasPermission: boolean = false;
  dlPerformanceReportPermission: boolean = false;
  endDate: string = '';
  startDate: string = '';
  projectName: string = '';
  current: number = 1;
  statusList: any[] = statusList;
  status: number = 0;
  total: number = 0;
  loading: boolean = false;
  unrealizedColmunObj: object = unrealizedColmunObj;
  realizedColmunObj: object = realizedColmunObj;
  pageSizeOptions: any[] = ['10', '20', '50', '100', '200'];
  height: number = 0;
  tableKey: string = `${Math.random()}`;
  exportLoading: boolean = false;
  isFold: boolean = true;
  totalDataList: any[] = [];
  sumLen: number = 0;
  totalSumLen: number = 0;
  shortDataList: any[] = [];
  isLoading: boolean = false;

  mounted() {
    this.height = window.innerHeight - 400;
    window.onresize = () => {
      return (() => {
        this.height = window.innerHeight - 400;
      })();
    };
    this.columns = middlePageColumns.slice(0);
    this.getColumns();
    this.getPermission();
    this.getSelects();
    this.getList();
  }

  async getPermission() {
    try {
      let res = await reportList();
      if (res.code === 200) {
        const exportList = res.data.filter(_ => _.id === 5)[0].export.map(_ => _.id);
        const { id } = this.userInfo || {};
        this.hasPermission = exportList.indexOf(id) > -1;
        let { permissions } = this.userInfo || {};
        this.dlPerformanceReportPermission = pathPermission(permissions, '/data/report/middlePage/dlPerformance');
      }
    } catch (err) {
      console.log(err);
    }
  }

  async getSelects() {
    try {
      let res = await searchByName();
      if (res.code === 200) {
        this.NickNameList = res.data.list;
        this.NickNameList.unshift({ id: '', nickname: '全部项目DL(天池)' });
      }
    } catch (err) {
      console.log(err);
    }
  }

  async getList() {
    this.data = [];
    this.totalDataList = [];
    this.shortDataList = [];
    this.sumLen = 0;
    this.totalSumLen = 0;
    this.isFold = true;
    this.isLoading = false;
    try {
      this.loading = true;
      let res = await middlePageList({
        page: this.page,
        pageSize: this.pageSize,
        projectName: this.projectName,
        // currency: this.currency,
        status: this.status,
        endDate: this.endDate,
        startDate: this.startDate,
        tianchiDlId: this.nickName
      });
      this.loading = false;
      if (res.code === 200) {
        this.total = res.data.total;
        this.sumLen = 0;
        if (res.data.list.length > 0) {
          res.data.list.forEach(_ => {
            let len = 0;
            if (_.invest.length > 0) {
              this.getData(this.totalDataList, 0, _);
              this.getData(this.data, 1, _);
            } else {
              len = 1;
              let data = {
                ..._.baseInfo,
                len: 1,
                isEmptyInvest: true
              };
              Object.keys(_.fmvRealized).forEach(key => {
                Object.assign(data, { [`realized${key}`]: _.fmvRealized[key] });
              });
              Object.keys(_.fmvUnrealized).forEach(key => {
                Object.assign(data, { [`unrealized${key}`]: _.fmvUnrealized[key] });
              });
              Object.keys(_.latest).forEach(key => {
                Object.assign(data, { [`latest${key}`]: _.latest[key] });
              });
              this.data.push({ ...data });
              this.totalDataList.push({ ...data });
              this.sumLen += len;
              this.totalSumLen += len;
            }
          });
          if (res.data.sum) {
            this.data.unshift({ total: 'total', ...res.data.sum });
            this.totalDataList.unshift({ total: 'total', ...res.data.sum });
          }
        }
        this.shortDataList = this.data.slice(0);
      }
    } catch (err) {
      console.log(err);
    }
  }

  getData(dataArr, key, arr) {
    let investLenArr: any[] = [];
    let unRealizedDetailLen = 0;
    let len = 0;
    let investArr: any[] = [];
    let sumlen = 0;
    if (key === 0) {
      investArr = arr.invest.slice(0);
      sumlen = this.totalSumLen;
    } else if (key === 1) {
      investArr = arr.invest.slice(0, 2);
      sumlen = this.sumLen;
    }
    investArr.forEach(e => {
      if (e.unRealizedDetail.penetrateFund) {
        unRealizedDetailLen = e.unRealizedDetail.penetrateFund.length + 1;
      } else {
        unRealizedDetailLen = 1;
      }
      let realizedDetailLen = 0;
      e.exitList.forEach(item => {
        if (item.realizedDetail.penetrateFund) {
          realizedDetailLen += item.realizedDetail.penetrateFund.length + 1;
        } else {
          realizedDetailLen += 1;
        }
      });
      investLenArr.push(realizedDetailLen > unRealizedDetailLen ? realizedDetailLen : unRealizedDetailLen);
    });
    len = investLenArr.reduce((num, cur) => {
      num += +cur;
      return num;
    }, 0);
    let data = {
      ...arr.baseInfo
    };
    Object.keys(arr.fmvRealized).forEach(key => {
      Object.assign(data, { [`realized${key}`]: arr.fmvRealized[key] });
    });
    Object.keys(arr.fmvUnrealized).forEach(key => {
      Object.assign(data, { [`unrealized${key}`]: arr.fmvUnrealized[key] });
    });
    Object.keys(arr.latest).forEach(key => {
      Object.assign(data, { [`latest${key}`]: arr.latest[key] });
    });
    let tmp = len;
    while (tmp > 0) {
      dataArr.push({ ...data });
      tmp--;
    }
    dataArr[sumlen]['len'] = len;
    let lenTmp = sumlen;
    investArr.forEach((e, index) => {
      let tmp = investLenArr[index];
      let investInfo = e.investInfo;
      let eventInfo = e.eventInfo;
      while (tmp > 0) {
        Object.keys(investInfo).forEach(key => {
          Object.assign(dataArr[lenTmp], { [`invest${key}`]: investInfo[key] });
        });
        Object.keys(eventInfo).forEach(key => {
          Object.assign(dataArr[lenTmp], { [key]: eventInfo[key] });
        });
        dataArr[lenTmp]['investInfoLen'] = tmp === investLenArr[index] ? investLenArr[index] : 0;
        tmp--;
        lenTmp++;
      }
    });
    lenTmp = sumlen;
    investArr.forEach((e, index) => {
      let unRealizedDetail = e.unRealizedDetail;
      let tmp2 = 0;
      Object.assign(dataArr[lenTmp], {
        unRealizedDetailClassOfShare: unRealizedDetail.classOfShare || '',
        unRealizedDetailFundName: unRealizedDetail.fundName || '',
        unRealizedDetailMoic: unRealizedDetail.moic || '',
        unRealizedDetailName: unRealizedDetail.fundName,
        unRealizedDetailCurrency: unRealizedDetail.currency,
        unRealizedDetailInvestmentCost: unRealizedDetail.investmentCost,
        unRealizedDetailShareNum: unRealizedDetail.shareNum,
        unRealizedDetailSharePercent: unRealizedDetail.sharePercent,
        unRealizedDetailFmv: unRealizedDetail.fmv,
        unRealizedDetailOwnValue: unRealizedDetail.ownValue,
        adjustMinusCost: unRealizedDetail.adjustMinusCost,
        adjust: unRealizedDetail.adjust
        // unRealizedPenetrateLen:e.penetrateFund.length
      });
      lenTmp++;
      tmp2++;
      unRealizedDetail.penetrateFund.forEach((item, i) => {
        Object.assign(dataArr[lenTmp], {
          unRealizedDetailName: item.name,
          unRealizedDetailCurrency: item.currency,
          unRealizedDetailInvestmentCost: item.investmentCost,
          unRealizedDetailShareNum: item.shareNum,
          unRealizedDetailSharePercent: item.sharePercent,
          unRealizedDetailFmv: item.fmv,
          unRealizedDetailOwnValue: item.ownValue,
          adjustMinusCost: item.adjustMinusCost,
          unRealizedDetailMoic: item.moic
        });
        lenTmp++;
        tmp2++;
      });
      if (investLenArr[index] !== tmp2) {
        let diff = investLenArr[index] - tmp2;
        while (diff > 0) {
          dataArr[lenTmp]['isUnRealizedEmpty'] = true;
          lenTmp++;
          diff--;
        }
      }
    });
    lenTmp = sumlen;
    investArr.forEach((e, index) => {
      let tmp2 = 0;
      if (e.exitList.length === 0) {
        let tmp = investLenArr[index];
        while (tmp > 0) {
          dataArr[lenTmp]['isExitEmpty'] = true;
          lenTmp++;
          tmp--;
        }
      } else {
        e.exitList.forEach((item, i) => {
          let realizedDetail = item.realizedDetail;
          let realizedDetailLen = realizedDetail.penetrateFund ? realizedDetail.penetrateFund.length + 1 : 1;
          let exitInfo = item.exitInfo;
          let tmp = realizedDetailLen;
          while (tmp > 0) {
            Object.assign(dataArr[lenTmp], {
              exitId: exitInfo.dealId,
              exitdlName: exitInfo.dlName,
              investId: exitInfo.investId,
              exitEffectDate: exitInfo.effectDate,
              exitType: exitInfo.exitType,
              exitFundName: exitInfo.fundName,
              exitDealType: exitInfo.dealType,
              exitCurrency: exitInfo.currency,
              exitDeliveryDate: exitInfo.deliveryDate,
              exitClassOfShare: exitInfo.classOfShare,
              exitAmount: exitInfo.amount,
              exitShareNum: exitInfo.shareNum,
              exitShareUnitPrice: exitInfo.shareUnitPrice,
              exitInvestmentCost: exitInfo.investmentCost,
              exitPenetrateFund: exitInfo.penetrateFund,
              allocatedAmount: exitInfo.allocatedAmount,
              exitOpponent: exitInfo.exitOpponent,
              exitReturn: exitInfo.exitReturn
            });
            dataArr[lenTmp]['realizedPenetrateLen'] = realizedDetailLen === tmp ? realizedDetailLen : 0;
            tmp--;
            lenTmp++;
            tmp2++;
          }
        });
        if (investLenArr[index] !== tmp2) {
          let diff = investLenArr[index] - tmp2;
          while (diff > 0) {
            dataArr[lenTmp]['isRealizedEmpty'] = true;
            lenTmp++;
            diff--;
          }
        }
      }
    });
    lenTmp = sumlen;
    investArr.forEach((e, index) => {
      let tmp2 = 0;
      if (e.exitList.length === 0) {
        let investLenArrLen = investLenArr[index];
        lenTmp += investLenArrLen;
      } else {
        e.exitList.forEach((item, i) => {
          let realizedDetail = item.realizedDetail;
          Object.assign(dataArr[lenTmp], {
            realizedDetailClassOfShare: realizedDetail.classOfShare,
            realizedDetailFundName: realizedDetail.fundName,
            realizedDetailName: realizedDetail.fundName,
            realizedDetailMoic: realizedDetail.moic,
            realizedDetailCurrency: realizedDetail.currency,
            realizedDetailInvestmentCost: realizedDetail.investmentCost,
            realizedDetailShareNum: realizedDetail.shareNum,
            realizedDetailProceeds: realizedDetail.proceeds
          });
          lenTmp++;
          tmp2++;
          realizedDetail.penetrateFund.forEach((obj, index) => {
            Object.assign(dataArr[lenTmp], {
              realizedDetailName: obj.name,
              realizedDetailCurrency: obj.currency,
              realizedDetailInvestmentCost: obj.investmentCost,
              realizedDetailShareNum: obj.shareNum,
              realizedDetailProceeds: obj.proceeds,
              realizedDetailMoic: obj.moic
            });
            lenTmp++;
            tmp2++;
          });
        });
      }
    });
    if (key === 0) {
      this.totalSumLen += len;
    } else if (key === 1) {
      this.sumLen += len;
    }
  }

  getColumns() {
    this.columns.forEach((e, index) => {
      if (index === 0) {
        e.children.forEach((item, i) => {
          item['customRender'] = function(val, row, index) {
            const obj = {
              children: val,
              attrs: {}
            };
            if (row.total) {
              obj['children'] = <span style="font-weight:bold">合计</span>;
              return obj;
            }
            if (!row.len) {
              obj.attrs['rowSpan'] = 0;
            } else {
              obj.attrs['rowSpan'] = row.len;
            }
            return obj;
          };
        });
      } else if (index > 0 && index < 5) {
        e.children.forEach((item, i) => {
          if (Object.keys(sumMap).indexOf(item.key) > -1) {
            item['customRender'] = function(val, row, index) {
              if (row.total) {
                let tmp = sumMap[item.key];
                return row[tmp];
              }
              const obj = {
                children: val,
                attrs: {}
              };
              if (!row.len) {
                obj.attrs['rowSpan'] = 0;
              } else {
                obj.attrs['rowSpan'] = row.len;
              }
              return obj;
            };
          } else {
            item['customRender'] = function(val, row, index) {
              if (row.total) {
                return '';
              }
              const obj = {
                attrs: {},
                children: val
              };
              if (!row.len) {
                obj.attrs['rowSpan'] = 0;
              } else {
                obj.attrs['rowSpan'] = row.len;
              }
              return obj;
            };
          }
        });
      } else if (index >= 5 && index < 8) {
        e.children.forEach((item, i) => {
          if (item.key === 'investpenetrateFund') {
            item['customRender'] = function(val, row, index) {
              if (row.total) {
                return '';
              }
              if (row.isEmptyInvest) {
                return '';
              }
              const obj = {
                children:
                  val && val.length > 0 ? (
                    <div>
                      {val.map(item => (
                        <li>
                          {item.name}（{item.percent};{item.cost}）
                        </li>
                      ))}
                    </div>
                  ) : (
                    <div></div>
                  ),
                attrs: {}
              };
              if (row.investInfoLen === 0) {
                obj.attrs['rowSpan'] = 0;
              } else if (!row.investInfoLen) {
                obj['children'] = <span style="display:none">{val}</span>;
              } else {
                obj.attrs['rowSpan'] = row.investInfoLen;
              }
              return obj;
            };
          } else {
            item['customRender'] = function(val, row, index) {
              if (row.total) {
                return '';
              }
              if (row.isEmptyInvest) {
                return '';
              }
              const obj = {
                children: val,
                attrs: {}
              };
              if (row.investInfoLen === 0) {
                obj.attrs['rowSpan'] = 0;
              } else if (!row.investInfoLen) {
                obj['children'] = <span style="display:none">{val}</span>;
              } else {
                obj.attrs['rowSpan'] = row.investInfoLen;
              }

              return obj;
            };
          }
        });
      } else if (index === 8) {
        e.children.forEach((item, i) => {
          if (item.key === 'exitPenetrateFund') {
            item['customRender'] = function(val, row, index) {
              if (row.total) {
                return '';
              }
              if (row.isEmptyInvest) {
                return '';
              }
              const obj = {
                children:
                  val && val.length > 0 ? (
                    <div>
                      {val.map(item => (
                        <li>
                          {item.name}（{item.percent};{item.cost}）
                        </li>
                      ))}
                    </div>
                  ) : (
                    <div></div>
                  ),
                attrs: {}
              };
              if (row.isExitEmpty) {
                obj.attrs['rowSpan'] = row.investInfoLen;
                return obj;
              }
              if (row.isRealizedEmpty) {
                obj.attrs['rowSpan'] = 1;
              } else {
                if (row.realizedPenetrateLen === 0) {
                  obj.attrs['rowSpan'] = 0;
                } else if (!row.realizedPenetrateLen) {
                  obj['children'] = <span style="display:none">{val}</span>;
                } else {
                  obj.attrs['rowSpan'] = row.realizedPenetrateLen;
                }
              }
              return obj;
            };
          } else {
            item['customRender'] = function(val, row, index) {
              if (row.total) {
                return '';
              }
              if (row.isEmptyInvest) {
                return '';
              }
              const obj = {
                children: val,
                attrs: {}
              };
              if (row.isExitEmpty) {
                obj.attrs['rowSpan'] = row.investInfoLen;
                return obj;
              }
              if (row.isRealizedEmpty) {
                obj.attrs['rowSpan'] = 1;
              } else {
                if (row.realizedPenetrateLen === 0) {
                  obj.attrs['rowSpan'] = 0;
                } else if (!row.realizedPenetrateLen) {
                  obj['children'] = <span style="display:none">{val}</span>;
                } else {
                  obj.attrs['rowSpan'] = row.realizedPenetrateLen;
                }
              }
              return obj;
            };
          }
        });
      }
    });
  }

  setUnrealizedColmuns() {
    if (this.unrealizedFold) {
      let unrealizedColmunObj = { ...this.unrealizedColmunObj };
      unrealizedColmunObj['children'].forEach((e, index) => {
        if (index === 0 || index === 1) {
          e['customRender'] = function(val, row, index) {
            if (row.total) {
              return '';
            }
            if (row.isEmptyInvest) {
              return '';
            }
            const obj = {
              children: val,
              attrs: {}
            };
            if (row.investInfoLen === 0) {
              obj.attrs['rowSpan'] = 0;
            } else if (!row.investInfoLen) {
              obj['children'] = <span style="display:none">{val}</span>;
            } else {
              obj.attrs['rowSpan'] = row.investInfoLen;
            }
            return obj;
          };
        } else {
          e['customRender'] = function(val, row, index) {
            if (row.total) {
              return '';
            }
            if (row.isEmptyInvest) {
              return '';
            }
            const obj = {
              children: val,
              attrs: {}
            };
            if (row.isUnRealizedEmpty) {
              obj.attrs['rowSpan'] = 1;
            }
            return obj;
          };
        }
      });
      this.columns.splice(8, 0, unrealizedColmunObj);
    } else {
      this.columns.splice(8, 1);
      this.tableKey = `${Math.random()}`;
    }
    this.unrealizedFold = !this.unrealizedFold;
  }

  setRealizedColmuns() {
    if (this.realizedFold) {
      let realizedColmunObj = { ...this.realizedColmunObj };
      realizedColmunObj['children'].forEach((e, index) => {
        if (index === 0 || index === 1) {
          e['customRender'] = function(val, row, index) {
            if (row.total) {
              return '';
            }
            const obj = {
              children: val,
              attrs: {}
            };
            if (row.isExitEmpty) {
              obj.attrs['rowSpan'] = row.investInfoLen;
              return obj;
            }
            if (row.realizedPenetrateLen === 0) {
              obj.attrs['rowSpan'] = 0;
            } else if (!row.realizedPenetrateLen) {
              obj['children'] = <span style="display:none">{val}</span>;
            } else {
              obj.attrs['rowSpan'] = row.realizedPenetrateLen;
            }
            return obj;
          };
        } else {
          e['customRender'] = function(val, row, index) {
            if (row.total) {
              return '';
            }
            const obj = {
              children: val,
              attrs: {}
            };
            if (row.isExitEmpty) {
              obj.attrs['rowSpan'] = row.investInfoLen;
              return obj;
            }
            if (row.isRealizedEmpty) {
              obj.attrs['rowSpan'] = 1;
            }
            return obj;
          };
        }
      });
      this.columns.push(realizedColmunObj);
    } else {
      this.columns.pop();
      this.tableKey = `${Math.random()}`;
    }
    this.realizedFold = !this.realizedFold;
  }

  onChange(date, dateString) {
    this.endDate = date ? moment(date).format('YYYYMMDD') : '';
    this.page = 1;
    this.current = 1;
    this.getList();
  }
  startOnChange(date, dateString) {
    this.startDate = date ? moment(date).format('YYYYMMDD') : '';
    this.page = 1;
    this.current = 1;
    this.getList();
  }

  handleSearch(val) {
    this.projectName = val;
    this.page = 1;
    this.current = 1;
    this.getList();
  }

  DLChange(val) {
    this.page = 1;
    this.nickName = val;
    this.current = 1;
    this.getList();
  }

  currencyChange(val) {
    this.page = 1;
    this.currency = val;
    this.current = 1;
    this.getList();
  }

  statusChange(val) {
    this.page = 1;
    this.status = val;
    this.current = 1;
    this.getList();
  }

  filterOption(input, option) {
    return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0;
  }

  queryList() {
    this.isFold = true;
    this.current = 1;
    this.page = 1;
    this.getList();
  }

  async exportReport() {
    try {
      let date = moment(new Date()).format('YYYYMMDD');
      let data = {
        projectName: this.projectName,
        currency: this.currency,
        status: this.status,
        endDate: this.endDate,
        startDate: this.startDate,
        dlId: this.nickName
      };
      this.exportLoading = true;
      this.$message.info('当前报表正在导出，预计时间较长，请稍后查看');
      let taskRes = await creatDownloadTask(data);
      const task = taskRes.data;
      while (true) {
        try {
          let status = await downloadTaskcheckTask(task);
          if (status.data) {
            downloadStreamFile('/dataService/download-task/download?id=' + task, {}, `北冥中间页数据报表_${date}`);
            this.exportLoading = false;
            break;
          }
          await new Promise<void>((resolve, rej) => {
            setTimeout(() => {
              resolve();
            }, 1000);
          });
        } catch (e) {
          console.error(e);
        }
      }
    } catch (err) {
      console.log(err);
    }
  }

  async exportDlPerformanceReport() {
    try {
      let date = moment(new Date()).format('YYYYMMDD');
      let data = {
        projectName: this.projectName,
        currency: this.currency,
        status: this.status,
        endDate: this.endDate,
        startDate: this.startDate,
        dlId: this.nickName
      };
      this.$message.info('当前报表正在导出，预计时间较长，请稍后查看');
      await downloadStreamFile('/dataService/reportForm/middlePageData/performanceDownload', data, `DL业绩表_${date}`);
    } catch (err) {
      console.log(err);
    }
  }

  onShowSizeChange(current, pageSize) {
    this.pageSize = pageSize;
    this.page = 1;
    this.current = 1;
    this.getList();
  }

  changePage(page, pageSize) {
    this.page = page;
    this.getList();
  }

  async unFoldReport() {
    this.isLoading = true;
    this.loading = true;
    setTimeout(() => {
      this.isFold = !this.isFold;
      if (!this.isFold) {
        this.data = this.totalDataList.slice(0);
      } else {
        this.data = this.shortDataList.slice(0);
      }
      this.tableKey = `${Math.random()}`;
      this.$nextTick(() => {
        this.isLoading = false;
        this.loading = false;
      });
    }, 500);
  }
}

export default MIDDLEPAGEREPORT;
